import { useTranslation } from "react-i18next";

export function useFormatAgeRange() {
    const [t] = useTranslation("availability");

    return (minAge: number | null | undefined, maxAge: number | null | undefined) => {
        const hasMinAge = typeof minAge === "number";
        const hasMaxAge = typeof maxAge === "number";

        if (hasMaxAge && hasMinAge) {
            if (minAge === 0 && maxAge === 0) return "";

            if (minAge === 0) {
                return t("price.ageRange_under", { age: maxAge });
            }

            if (maxAge >= 99) {
                return t("price.ageRange_over", { age: minAge });
            }

            return t("price.ageRange_between", { minAge, maxAge });
        }

        if (hasMaxAge) return t("price.ageRange_under", { age: maxAge });
        if (hasMinAge) return t("price.ageRange_over", { age: minAge });
        else return "";
    };
}
